import {
  CURRENT_LANGUAGE,
  humanReadableLanguage,
  updateLanguage,
  languageExample,
} from "../../../services/localize";

import { useState } from "react";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import DemoNote from "../../../ui-components/demo-note/demo-note";
import { Size } from "../../../logic/enums.ts";

const LanguageOptionElement = ({ value, setNewLanguage, newLanguage }) => {
  const isSelected = newLanguage === value;

  const onClick = () => {
    setNewLanguage(value);
  };

  const text = humanReadableLanguage(value);
  const example = languageExample(value);

  let borderColor = "border-color-raindrop-minor";

  if (isSelected) {
    borderColor = "border-color-raindrop-primary";
  }

  return (
    <div
      onClick={onClick}
      className={`border-b  p-2  ${borderColor} text-left md:hover:scale-95 transition-all`}
    >
      <div className="text-lg font-bold">{text}</div>
      <div className="text-color-raindrop-minor-again">{example}</div>
    </div>
  );
};

const RaindropSettingsLanguage = () => {
  const [newLanguage, setNewLanguage] = useState(CURRENT_LANGUAGE);

  const onConfirm = () => {
    updateLanguage(newLanguage);
  };

  return (
    <div className={"flex flex-col h-full gap-4 pt-6 "}>
      <RaindropButton
        title={"Back"}
        icon={"fa-chevron-left"}
        to={"/raindrop/settings"}
        isPrimary={false}
        style={ButtonStyle.Secondary}
        size={Size.Large}
      />

      <div id={"languages-list"} className={"flex flex-col gap-2"}>
        <DemoNote text={"Localisation is not complete for this demo"} />

        <LanguageOptionElement
          value={"TE_REO"}
          setNewLanguage={setNewLanguage}
          newLanguage={newLanguage}
        />
        <LanguageOptionElement
          value={"ENGLISH"}
          setNewLanguage={setNewLanguage}
          newLanguage={newLanguage}
        />
        <LanguageOptionElement
          value={"HINDI"}
          setNewLanguage={setNewLanguage}
          newLanguage={newLanguage}
        />
      </div>

      <div class="flex flex-col w-full items-center justify-center mt-auto">
        <RaindropButton
          title={"Confirm"}
          onClick={onConfirm}
          to={"/raindrop/settings"}
          isDisabled={newLanguage === CURRENT_LANGUAGE}
          style={ButtonStyle.Primary}
          isFluid={true}
          size={Size.Large}
        />
      </div>
    </div>
  );
};

export default RaindropSettingsLanguage;
